import { FAIcon } from "./faIcon.js";
import { HTTPService } from "../util/httpManager.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { Commands } from "../util/commandManager.js";
import { Config } from "../config/config.js";
import { EventType } from "../../../siteManagement/eventManager.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import * as addressDetails from "./templates/addressDetails";
import * as resourceDetails from "./templates/resourceDetails";
import * as projectDetails from "./templates/projectDetails";
import * as deliverableTypeDetails from "./templates/deliverableTypeDetails";
import * as userDetails from "./templates/userDetails";
import * as procedureArticleDetails from "./templates/procedureArticleDetails";
import * as procedureDetails from "./templates/procedureDetails"
import * as contactPersonDetails from "./templates/contactPersonDetails"
import * as assignmentDetails from "./templates/assignmentDetails"
import * as articleDetails from "./templates/articleDetails"
import * as  machineDetails from "./templates/machineDetails";
import * as slaServiceHoursDetails from "./templates/slaServiceHoursDetails";
import React from "react";

interface CustomPanelbarRegistration {
    component: React.ComponentType<any>;
    isDataAvailable?: (data: any) => boolean;
}

const customPanelbarRegistry: { [key: string]: CustomPanelbarRegistration } = {};

export function registerCustomPanelbar(
    name: string,
    component: React.ComponentType<any>,
    isDataAvailable?: (data: any) => boolean
) {
    if (name) {
        customPanelbarRegistry[name.toLowerCase()] = { component, isDataAvailable };
    }
}

export class IsPanelbarDetails extends React.Component<IsPanelbarDetailsProps, PanelBarState> {
    private _panelbarElement: any;
    private _panelbar: kendo.ui.PanelBar = null;
    private _defined = Helper.hasValue;


    constructor(props: IsPanelbarDetailsProps) {
        super(props);

        const state: PanelBarState = {
            isKnownModule: false,
            moduleLoaded: false,
            moduleContextType: this._getKnownObjectTypes(props.field.template),
            moduleName: this._getKnownModules(props.field.template),
            appName: null,
            data: null,
            module: null,
            customIsDataAvailable: null
        };

        if (state.moduleName !== null) {
            state.isKnownModule = true;
        }
        this.state = state;
    }


    private _loadData = () => {
        if (this._defined(this.props.field.url)) {
            if (!this._defined(this.props.value) || this.props.value === "") {
                this.setState({ data: null });
            } else {
                if (typeof this.props.value === 'object') {
                    HTTPService.post(this.props.field.url, { id: this.props.value })
                        .then(data => {
                            this.setState({ data: data });
                            this.props.onDataLoaded(this.props.field, data);
                        });
                } else {
                    HTTPService.post(this.props.field.url + "?id=" + encodeURIComponent(this.props.value))
                        .then(data => {
                            this.setState({ data: data });
                            this.props.onDataLoaded(this.props.field, data);
                        });
                }
            }
        }
    }
    private _getModuleByName = (name: string) => {
        switch (name.toLowerCase()) {
            case "slaservicehoursdetails":
                return slaServiceHoursDetails;
            case "addressdetails":
                return addressDetails;
            case "machinedetails":
                return machineDetails;
            case "articledetails":
                return articleDetails;
            case "assignmentdetails":
                return assignmentDetails;
            case "contactpersondetails":
                return contactPersonDetails;
            case "proceduredetails":
                return procedureDetails;
            case "procedurearticledetails":
                return procedureArticleDetails;
            case "projectdetails":
                return projectDetails;
            case "resourcedetails":
                return resourceDetails;
            case "userdetails":
                return userDetails;
            case "deliverabletypedetails":
                return deliverableTypeDetails;
            default:
                return null;
        }

    }

    private _getKnownModules = (name: string) => {
        switch (name.toLowerCase()) {
            case "slaservicehoursdetails":
                return "./templates/slaServiceHoursDetails";
            case "addressdetails":
                return "./templates/addressDetails";
            case "machinedetails":
                return "./templates/machineDetails";
            case "articledetails":
                return "./templates/articleDetails";
            case "assignmentdetails":
                return "./templates/assignmentDetails";
            case "contactpersondetails":
                return "./templates/contactPersonDetails";
            case "proceduredetails":
                return "./templates/procedureDetails";
            case "procedurearticledetails":
                return "./templates/procedureArticleDetails";
            case "projectdetails":
                return "./templates/projectDetails";
            case "resourcedetails":
                return "./templates/resourceDetails";
            case "userdetails":
                return "./templates/userDetails";
            case "deliverabletypedetails":
                return "./templates/deliverableTypeDetails"
            default:
                return null;
        }
    }
    private _getKnownObjectTypes = (name: string) => {
        switch (name.toLowerCase()) {
            case "slaservicehoursdetails":
                return "slaservicehours";
            case "addressdetails":
                return "address";
            case "machinedetails":
                return "machine";
            case "articledetails":
                return "parts";
            case "contactpersondetails":
                return "contact";
            case "projectdetails":
                return "project";
            case "resourcedetails":
                return "resource";
            default:
                return null;
        }
    }
    private _onCollapse(e: any) {
        $(e.item).children().removeClass('k-selected k-focus');
    }
    private _loadModule = () => {
        const templateName = (this.props.field.template || "").toLowerCase();
        const customRegistration = customPanelbarRegistry[templateName];
        let module: any = null;
        let customIsDataAvailable: ((data: any) => boolean) | undefined = undefined;

        if (this._defined(customRegistration)) {
            module = customRegistration.component;
            customIsDataAvailable = customRegistration.isDataAvailable;
        } else {
            const response = this._getModuleByName(this.props.field.template);
            if (this._defined(response)) {
                module = response.default;
            }
        }

        this.setState({ moduleLoaded: true, module: module, customIsDataAvailable: customIsDataAvailable }, () => {
            if (typeof this.props.value === "object" || this._defined(this.props.value)) {
                this._loadData();
            }
            this._panelbar = $(this._panelbarElement).children().kendoPanelBar({ collapse: this._onCollapse }).data("kendoPanelBar");
        });
    }

    private _isDataAvaibable = () => {
        if (!Helper.hasValue(this.state.data)) {
            return false;
        }
        const data = Helper.getValueOrDefault(this.state.data.Data,
            Helper.getValueOrDefault(this.state.data.data,
                this.state.data));

        if (typeof this.state.customIsDataAvailable === "function") {
            return this.state.customIsDataAvailable(data);
        }

        const name = this.props.field.template;
        if (!name) {
            return false;
        }

        switch (name.toLowerCase()) {
            case "slaservicehoursdetails":
                return Helper.hasValue(data.SourceId);
            case "addressdetails":
                return Helper.hasValue(data.AdrNr);
            case "machinedetails":
                return Helper.hasValue(data.MaschNr);
            case "articledetails":
                return Helper.hasValue(data.ArtNr);
            case "assignmentdetails":
                return Helper.hasValue(data.ProjNr);
            case "contactpersondetails":
                return Helper.hasValue(data.Pos);
            case "proceduredetails":
                return Helper.hasValue(data.ProblemNr);
            case "projectdetails":
                return data && data.Project && Helper.hasValue(data.Project.ProjNr);
            case "procedurearticledetails":
                return Helper.hasValue(data.Bezeichnung);
            case "resourcedetails":
                return Helper.hasValue(data.Ressnr);
            case "userdetails":
                return Helper.hasValue(data.Name);
            default:
                return false;
        }
    }

    private _reloadData = (data: any) => {
        if (data.context === this.state.moduleContextType) {
            this._loadData();
        }
    }

    componentDidMount() {
        if (this._defined(this.props.commandManager)) {
            this.props.commandManager.registerExecutor(this.props.field.model, (command, _data) => {
                if (command === Commands.REFRESH) {
                    this._loadData();
                }
            });
        }
        General.Events.bind(EventType.SavedSuccessfully, this._reloadData);
        this._loadModule();
    }

    componentWillUnmount() {
        General.Events.unbind(EventType.SavedSuccessfully, this._reloadData);
        if (this._defined(this._panelbar)) {
            this._panelbar.destroy();
        }
    }

    //shouldComponentUpdate(nextProps, nextState) {
    //    // Update der Komponente ist nur notwendig wenn value sich geändert hat oder die einzusetzenden Daten neu geholt wurden und damit eine Initialisierung dwes Panels notwendig ist
    //    return this._contentMode || this._value != nextProps.value || this._newDataLoaded;
    //}

    componentDidUpdate(prevProps: IsPanelbarDetailsProps, _prevState: PanelBarState) {
        //if (!this._contentMode) {
        if (typeof this.props.value === "object") {
            if (JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value)) {
                this._loadData();
            }
        } else {
            if (this.props.value != prevProps.value) {
                this._loadData();
            }
        }
        //}
    }

    render() {
        const data = (Helper.hasValue(this.state.data)) ?
            (Helper.getValueOrDefault(this.state.data.Data, Helper.getValueOrDefault(this.state.data.data, this.state.data))) : null;
        const dataAvaibable = this._isDataAvaibable();
        const panelbar = (this.state.moduleLoaded ?
            <div ref={(e) => this._panelbarElement = e} className="fieldValue panelAsAccordionField" style={{ width: "100%", display: dataAvaibable ? null : "none" }} >
                {React.createElement(this.state.module, { data: data || {}, value: this.props.value })}
            </div>
            : null);
        const placeHolder = (<PanelbarPlaceHolder context={this.props.field.template} visible={!dataAvaibable} />);

        return (
            <>
                {panelbar}
                {placeHolder}
            </>
        );
    }
}

interface PanelBarState {
    isKnownModule: boolean;
    moduleName: string;
    moduleContextType: string;
    appName: string;
    moduleLoaded: boolean;
    data: any;
    module: any;
    customIsDataAvailable: (data: any) => boolean;
}

export class PanelbarStructure extends React.Component<PanelbarStructureProps, any> {
    private _spanElement: HTMLElement;

    //@ts-ignore
    handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.button == 1) {
            Helper.openInNewBrowserTab(Config.baseUrl + this.props.url);
        }
        else if (e.button == 0) {
            General.Sheet.Manager.createSheetWithUrl(Config.baseUrl + Helper.addUrlParameter(this.props.url, "isWindow=true"), null, null, true);
        }
    }

    componentDidMount() {
        if (this._spanElement) {
            $(this._spanElement).on('click', (e) => {
                e.stopPropagation();
            });
        }
    }

    render() {
        const link = this.props.iconName ?
            <span ref={(ref) => { this._spanElement = ref; }} style={{ display: "inline-block", paddingRight: "10px" }} onMouseUp={Helper.hasValue(this.props.url) ? this.handleMouseUp : null}> <FAIcon name={this.props.iconName} /></span > : null;

        return (
            <ul className="panelAsAccordion" style={{ marginBottom: "7px", width: "100%", display: Helper.hasValue(this.props.keyPropValue) ? "block" : "none" }}>
                <li>
                    <span>
                        {link}
                        {Helper.hasValue(this.props.label) && this.props.label !== "" ? this.props.label : "-"}
                    </span>
                    <ul>
                        <li>{this.props.children}</li>
                    </ul>
                </li>
            </ul>
        );
    }
}

class PanelbarPlaceHolder extends React.Component<PanelbarPlaceHolderProps, any> {
    private _getIconName = () => {
        switch (this.props.context.toLowerCase()) {
            case "addressdetails":
                return "home";
            case "machinedetails":
                return "cogs";
            case "articledetails":
            case "slaservicehoursdetails":
            case "procedurearticledetails":
                return "tag";
            case "assignmentdetails":
                return "calendar-check";
            case "contactpersondetails":
                return "id-badge";
            case "proceduredetails":
                return "exclamation-circle";
            case "projectdetails":
                return "folder-open";
            case "resourcedetails":
                return "child";
            case "userdetails":
                return "user-alt";
            default:
                return null;
        }
    }

    render() {

        const iconName = this._getIconName();

        const icon = iconName ?
            <span style={{ display: "inline-block", paddingRight: "10px", color: "#999" }} > <FAIcon name={iconName} /></span > : null;


        //@ts-ignore
        const style: React.CSSProperties = {
            height: "36px",
            display: this.props.visible ? "flex" : "none",
            alignItems: "center",
            paddingLeft: "14px",
            paddingRight: "14px",
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "#999",
            borderRadius: "var(--border-radius)"

        };

        return (<div className="k-panelbar" style={style}>{icon}</div>)
    }
}
export interface IsPanelbarDetailsProps extends BaseComponentProps {
    field: IsPanelbarDetailsField;
    commandManager: CommandManagerAPI;
    onDataLoaded?: (field: { model: string }, data: any) => void;
    handleEval?: (action: string, prepare?: any) => void;
}


//@ts-ignore
interface PanelbarStructureProps extends React.PropsWithChildren {
    label: string;
    keyPropValue: string;
    url?: string;
    iconName?: string;
}


interface PanelbarPlaceHolderProps {
    context: string;
    visible: boolean;
    //@ts-ignore
    style?: React.CSSProperties;

}

export interface IsPanelbarDetailsField extends BaseField {
    url?: string;
    template?: string;
    moduleName?: string;
    appName?: string;
}